module.exports = __webpack_public_path__ + "img/ov10_lac-pa-22980_cropped.5cd2dcf8.jpg";